module.exports = __webpack_public_path__ + "img/main-banner-2000.af944b27.jpg";